import {
  BadgeGreen,
  BadgeBlue,
  BadgePurple,
  BadgeAmber,
} from "../../components/badge/Badge";

import { SupplierPalletShipmentListResponseType } from "@sellar-io/api-v2/types";

export const shipmentStatus = (
  status: SupplierPalletShipmentListResponseType[number]["status"],
) => {
  switch (status) {
    case "open":
      return <BadgeAmber icon={"TIMER_SAND_EMPTY"}>Open</BadgeAmber>;
    case "readyToShip":
      return <BadgeGreen icon={"CHECK_CIRCLE"}>Ready to ship</BadgeGreen>;
    case "dispatched":
      return (
        <BadgePurple icon={"DELIVERY_BOX"}>Dispatched - in transit</BadgePurple>
      );
    case "received":
      return <BadgeBlue icon={"CHECK_ALL"}>Received</BadgeBlue>;
  }
};
